import { TaskReflection } from './task-reflection'
import { TaskTypeEnum } from './task-type-enum'
import { TaskStatusEnum } from './task-status-enum'
import { TaskSetting } from './task-setting'

export interface AnnouncementActivityTaskResInterface {
  /**
   * 前台用户请求接口
   *  - 返回当前用户【活动任务】完成情况
   */
  taskCompletedInfo?: TaskReflection | null
  /**
   * 后台用户请求接口
   *  - 是否有人提交
   */
  isSubmit?: boolean
  /**
   * 任务关联活动
   */
  activityId: number
  /**
   * 名称
   */
  name: string
  /**
   * 任务类型
   */
  type: TaskTypeEnum
  /**
   * 任务状态
   */
  status: TaskStatusEnum
  /**
   * 活动开始时间
   */
  startAt?: string | null
  /**
   * 活动结束时间
   */
  endAt?: string | null
  /**
   * 活动定时开始时间
   */
  timedStartAt?: string | null
  /**
   * 前序任务
   */
  prevTaskIds?: number[]
  /**
   * 是否显示
   */
  isShow?: boolean
  /**
   * 关联的试卷 ID
   */
  paperId?: number
  /**
   * 管理员 ID
   */
  adminIds?: number[]
  /**
   * 其它设置
   */
  setting?: TaskSetting
  /**
   * 描述
   */
  description: string
  /**
   * 权重
   */
  weight?: number
}

export class AnnouncementActivityTaskRes
  implements AnnouncementActivityTaskResInterface
{
  /**
   * 前台用户请求接口
   *  - 返回当前用户【活动任务】完成情况
   */
  taskCompletedInfo?: TaskReflection | null
  /**
   * 后台用户请求接口
   *  - 是否有人提交
   */
  isSubmit?: boolean
  /**
   * 任务关联活动
   */
  activityId: number
  /**
   * 名称
   */
  name: string
  /**
   * 任务类型
   */
  type: TaskTypeEnum
  /**
   * 任务状态
   */
  status: TaskStatusEnum
  /**
   * 活动开始时间
   */
  startAt?: string | null
  /**
   * 活动结束时间
   */
  endAt?: string | null
  /**
   * 活动定时开始时间
   */
  timedStartAt?: string | null
  /**
   * 前序任务
   */
  prevTaskIds?: number[]
  /**
   * 是否显示
   */
  isShow?: boolean
  /**
   * 关联的试卷 ID
   */
  paperId?: number
  /**
   * 管理员 ID
   */
  adminIds?: number[]
  /**
   * 其它设置
   */
  setting?: TaskSetting
  /**
   * 描述
   */
  description: string
  /**
   * 权重
   */
  weight?: number

  constructor(props: AnnouncementActivityTaskResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      taskCompletedInfo: _taskCompletedInfo,
      isSubmit: _isSubmit,
      activityId: _activityId,
      name: _name,
      type: _type,
      status: _status,
      startAt: _startAt,
      endAt: _endAt,
      timedStartAt: _timedStartAt,
      prevTaskIds: _prevTaskIds,
      isShow: _isShow,
      paperId: _paperId,
      adminIds: _adminIds,
      setting: _setting,
      description: _description,
      weight: _weight,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.taskCompletedInfo = _taskCompletedInfo
      ? new TaskReflection(_taskCompletedInfo)
      : _taskCompletedInfo
    this.isSubmit = _isSubmit
    this.activityId = _activityId
    this.name = _name
    this.type = _type
    this.status = _status
    this.startAt = _startAt
    this.endAt = _endAt
    this.timedStartAt = _timedStartAt
    this.prevTaskIds = _prevTaskIds
    this.isShow = _isShow
    this.paperId = _paperId
    this.adminIds = _adminIds
    this.setting = _setting ? new TaskSetting(_setting) : _setting
    this.description = _description
    this.weight = _weight
  }
}
